import React from 'react';
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="container overflow-hidden text-center my-auto">
      <div className="row gx-5 mb-5">
        <div className="col-12 col-md-6">
          <div className="selection-tile"><Link to="/blind-drawings">
            <h5>Blind Drawings</h5>
            <hr />
            <p>Hop on a call with a friend. They choose a random object and describe it with basic shapes. You draw out the shapes and try to guess the object they're describing.</p>
          </Link></div>
        </div>
        <div className="col-12 col-md-6">
          <div className="selection-tile"><Link to="/random-objects">
            <h5>Random Objects Game</h5>
            <hr />
            <p>You'll get random objects to solve tricky problems with! You have 60 seconds to find a solution to each problem, using ALL the random objects you get.</p>
          </Link></div>
        </div>
      </div>
      <div className="row gx-5">
        <div className="col-12 col-md-6">
         <div className="selection-tile"><Link to="/improv-presentations">
            <h5>Improv Presentations</h5>
            <hr />
            <p>You get a random topic and some random images. You use the images as your 'presentation slides'. Explain how the images connect to your topic in 60 seconds.</p>
          </Link></div>
        </div>
        <div className="col-12 col-md-6">
          <div className="selection-tile"><Link to="/idea-generator">
            <h5>Idea Generator</h5>
            <hr />
            <p>You'll get some creative idea prompts (ex: 'Best Hollywood Action Film'). See how many ideas you can come up with for the prompts in 60 seconds.</p>
          </Link></div>
        </div>
      </div>
    </div>
  );
}
